<template>
	<div class="p-5">
		<p class="text-secondary">Felkod: {{ error.code }}</p>
		<h1>{{ error.message }}</h1>
		<p>
			<img style="width: 100%" :src="convertToCdnUrl('/images/620751-felsida12002022?raw')" alt="error" />
		</p>
		<p>
			Sidan du vill besöka går inte att nå. Det kan vara en gammal eller trasig länk, eller så är felet tillfälligt. Förlåt oss i vilket fall! Pröva gärna att navigera via kategorimenyn eller <router-link :to="$router.route({ name: 'search' })">sök efter en produkt</router-link>.
		</p>
		<template v-if="suggestions.length > 0">
			<p style="font-weight: bold">
				{{ headerText }} du kanske är intresserad av:
			</p>
		</template>
		<div class="highlight-section" v-if="suggestions.length > 0">
			<div v-for="suggestion in suggestions" :key="suggestion.id" class="col-md-6 my-3">
				<router-link class="info-link r-3" :to="suggestion.router">
					<div class="p-4 pull-left mr-5 stretch-y category-highlight-name">
						<ximg
							:src="convertToCdnUrl('/api/dynimg/category/' + suggestion.icon + '/' + iconColor)"
							:ariaLabel="suggestion.name + ' ikon'"
							role="img"
						/>
					</div>
					<div class="category-highlight-description">
						{{ suggestion.name }}
					</div>
				</router-link>
			</div>
		</div>
		<div class="clearfix" />
	</div>
</template>

<script>
import { get } from 'lodash';
import bus from 'eventbus';
import router from 'router';
import store from 'datastore';
import metaHandler from 'metaHandler';
import { prerender } from 'staticData';
import { convertToCdnUrl } from 'utils';

export default {
	mounted: function () {
		metaHandler.set('robots', 'noindex, follow');
		this.$store.commit('productFilters/setFilterEnabled', false);
		if (this.error.code == 404) {
			metaHandler.set('prerender-status-code', '404');
		}
		this.notifyPrerenderer();
	},
	data () {
		return {
			iconColor: '1e222d',
		};
	},
	props: {
		error: {
			type: Object,
			default () {
				return {
					code: 404,
					message: 'Sidan kunde inte hittas', // @TODO från i18n
					data: [],
				};
			},
		},
	},
	computed: {
		_() {
			return _;
		},
		headerText () {
			if (this.dataType === 'campaign') {
				return 'Kampanjer';
			}
			return 'Kategorier';
		},
		dataType () {
			if (get(this.error, 'data.category', null) != null) {
				return 'category';
			} else if (get(this.error, 'data.product', null) != null) {
				return 'product';
			} else if (get(this.error, 'data.campaign', null) != null) {
				return 'campaign';
			}
			return null;
		},
		section () {
			let data = null;
			if (this.dataType === 'category' && get(this.error.data, 'data.' + this.dataType + '.section.active', false)) {
				data = get(this.error, 'data.' + this.dataType + '.section', null);
			} else if (get(this.error, 'data.' + this.dataType + '.section.active', false)) {
				data = get(this.error, 'data.' + this.dataType + '.section', null);
			}

			if (data != null) {
				return {
					id: data.id,
					name: data.name,
					router: router.route({ name: 'section', params: {  id: data.id, name: data.name }}),
					icon: data.icon,
					image: '/api/dynimg/category/' + data.icon + '/' + this.iconColor,
				};
			}
			return null;
		},
		categories () {
			const array = [];
			let data = null;

			if (get(this.error, 'data.' + this.dataType + '.path', null) != null) {
				data = get(this.error, 'data.' + this.dataType + '.path', null);
			} else if (get(this.error, 'data.' + this.dataType + '.mainCategoryPath', null) != null) {
				data = get(this.error, 'data.' + this.dataType + '.mainCategoryPath', null);
			}
			if (data != null) {
				for (const i in data) {
					const category = get(this.error, 'data.category.id', null);
					if (data[i].active && (category == null || data[i].id !== category)) {
						array.push({
							id: data[i].id,
							name: data[i].name,
							router: router.route({ name: 'category', params: {  id: data[i].id, name: data[i].name }}),
							icon: data[i].icon,
							image: '/api/dynimg/category/' + data[i].icon + '/' + this.iconColor,
						});
					}
				}
			}
			return array;
		},
		campaigns () {
			const array = [];

			array.push({
				id: 1,
				name: 'Alla kampanjer',
				router: router.route({ name: 'campaigns', params: {  }}),
				icon: 'kampanjer',
				image: '/api/dynimg/category/campaign/' + this.iconColor,
			});

			if (this.section != null) {
				array.push({
					id: 2,
					name: 'Kampanjer i ' + this.section.name,
					router: router.route({ name: 'campaigns', params: {  sectionId: this.section.id, name: 'Kampanjer i ' + this.section.name }}),
					icon: 'kampanjer',
					image: '/api/dynimg/category/campaign/' + this.iconColor,
				});
			}
			return array;
		},
		suggestions () {
			const array = [];
			if (this.dataType === 'campaign') {
				for (const item of this.campaigns) {
					array.push(item);
				}
			} else {
				if (this.section != null) {
					array.push(this.section);
				}
				for (const item of this.categories) {
					array.push(item);
				}
			}
			return array;
		},
	},
	methods: {
		convertToCdnUrl,
		notifyPrerenderer () {
			if (prerender) {
				Vue.nextTick(() => {
					// Signal the prerendering server that error page has been loaded.
					store.dispatch('prerender/pageError', this.error.code);
				});
			}
		},
	},
	watch: {
		error (error) {
			this.notifyPrerenderer();
		},
	},
};
</script>
